<template>
    <kinesis-element :strength="10" ref="loadingScreen" class="loading-screen">
      <svg version="1.1" id="Слой_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="-185 268 240 257" style="" xml:space="preserve">
      <path class="st0 mykUghmf_0" d="M29.4,521.2L-77.4,414.6l47.3,0.5c0,0,49.2-6.7,48.2-51.4s-46.5-51.3-46.5-51.3h-87v208.7"></path> <path class="st0 mykUghmf_1" d="M-13.5,270.5L-177,434.8L-115.4,496.8L46.9,335.3L14.5,303.5L-86,406L-77,415"></path> 
      </svg>
    </kinesis-element>
</template>

<script> 
import { TimelineLite } from 'gsap'
export default { 
    
  mounted() { 
    const { loadingScreen } = this.$refs
    const timeline = new TimelineLite() 
    
    timeline.to(loadingScreen, 1, { y: -0}) 
  } 
} 
</script>

      <style data-made-with="vivus-instant">
      .mykUghmf_0 {
          stroke-dasharray: 647 649;
          stroke-dashoffset: 648;
          animation: mykUghmf_draw1 700ms linear 0ms forwards;
      }

      .mykUghmf_1 {
          stroke-dasharray: 750 752;
          stroke-dashoffset: 751;
          animation: mykUghmf_draw 800ms linear 800ms forwards;
      }

      @keyframes mykUghmf_draw {
          100% {
              stroke-dashoffset: 0;
          }
      }
      @keyframes mykUghmf_draw1{
          100% {
              stroke-dashoffset: 1296;
          }
      }

      @keyframes mykUghmf_fade {
          0% {
              stroke-opacity: 1;
          }
          94.44444444444444% {
              stroke-opacity: 1;
          }
          100% {
              stroke-opacity: 0;
          }
      }

      </style>

            <style type="text/css"> .st0 {
          fill: none;
          stroke: #FFF;
          stroke-width: 8;
          stroke-miterlimit: 10;
      }

      </style>